import {type Module} from 'vuex';
import actions from './actions';
import getters from './getters';
import mutations from './mutations';

// state
const state: ISessionserviceState = {
    isAdmin: false,
    isFreeCouncil: false,

    groups: [],
    allMyGroups: [],
    myGroups: [],
    editableGroups: [],
    documentTypes: [],

    hierarchyFormats: {},
    settings: {} as ISessionserviceStateSettings,
    menu: false,
    exportExists: false,

    editActiveTopic: null,

    fetched: 0,
};

// module
const sessionservice: Module<ISessionserviceState, RootState> = {
    namespaced: true,
    state,
    actions,
    mutations,
    getters,
};

export default sessionservice;